<script setup>
import BirdFly from '@images/bird-fly.webp'
import { computed } from 'vue'

const props = defineProps({
  extraSmall: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  showText: {
    type: Boolean,
    default: true
  },
  customText: {
    type: String,
    default: null
  }
})

// Sized on first render, not in onMounted: under a v-if the component remounts on every
// show, so a post-mount reassignment paints the default size for a frame and then pops.
const size = computed(() => {
  if (props.extraSmall) { return { width: 20, height: 18 } }
  if (props.small) { return { width: 25, height: 23 } }
  return { width: 34, height: 31 }
})
</script>
<template>
  <div class="flex">
    <div
      v-if="showText"
      class="text-base"
      :class="{
        'text-purple-700': true,
        'pt-[3px] pr-4 lg:font-medium': !small,
        'pr-2 relative top-[-1px]': small
      }"
    >
      <span v-if="customText">{{ customText }}</span>
      <span v-else>{{ $trans('LoadingSpinner.Loading') }}</span>
    </div>
    <div class="relative top-[2px]">
      <img :height="size.height" :width="size.width" alt="loading-bird" :src="BirdFly">
    </div>
  </div>
</template>
<style lang="scss">

</style>
